import React from "react";
import "./Explore_Latest_Banner.css";
import Breadcrumb_Comp from "../../common/common_components/breadcrumb_comp/Breadcrumb_Comp";

const Explore_Latest_Banner = ({ banner }) => {
  const breadcrumbs = [
    { label: "EXPLORE", link: "/EXPLORE", active: false },
    { label: "EXPLORE LATEST PRODUCTS", link: "", active: true },
  ];

  return (
    <section className="Explore_Latest_Banner">
      <div className="container">
        <Breadcrumb_Comp data={breadcrumbs} />

        <div className="banner_holder">
          <img
            src={banner}
            className="banner_img"
          />
        </div>
      </div>
    </section>
  );
};

export default Explore_Latest_Banner;
